<script lang="ts">
  import { Row } from "sveltestrap";
  import {tempId} from "../../../store"
  import TimeLineContent from "./TimeLineContent.svelte";
  import SocialTimeLineLeft from "./SocialTimeLineLeft.svelte";
  import SocialTimeLineRight from "./SocialTimeLineRight.svelte";
  let setTempid:string
    tempId.subscribe((value)=>{
        setTempid = value
    })
</script>
<div class="tab-pane fade {setTempid === "top-timeline" ? "active show" : ""}" id="top-timeline" role="tabpanel" aria-labelledby="timeline">
    <Row>
        <SocialTimeLineLeft />
        <TimeLineContent />
        <SocialTimeLineRight />
    </Row>
</div>